import React, { PureComponent } from 'react';
import { NumericFormat as NumberFormat } from 'react-number-format';
import PropTypes from 'prop-types';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { getCurrencySymbol } from "../../helpers/WVUtilities";


class CurrencyField extends PureComponent {
  static propTypes = {
    currency: PropTypes.string,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.number,
    onBlur: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    allowEmptyFormatting: PropTypes.bool,
  };

  static defaultProps = {
    currency: 'USD',
    defaultValue: 0,
    disabled: false,
    placeholder: '',
    name: null,
    allowEmptyFormatting: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      changedAmount: undefined,
      value: isNaN(props.defaultValue) ? 0 : props.defaultValue,
    };
  }
  componentDidUpdate(prevProps) {
    this.shouldUpdateValue(prevProps);
  }
  shouldUpdateValue(prevProps) {
    const prevVal = isNaN(prevProps.defaultValue) ? 0 : prevProps.defaultValue;
    const currentVal = isNaN(this.props.defaultValue) ? 0 : this.props.defaultValue;
    const stateVal = isNaN(this.state.value) ? 0 : this.state.value;

    if (prevVal !== currentVal && currentVal !== stateVal) {
      this.setState({ value: currentVal });
    }
  }
  render() {
    const {
      disabled,
      defaultValue,
      onBlur,
      placeholder,
      name,
      allowEmptyFormatting,
      currency,
    } = this.props;
    const { value } = this.state;
    return (
      <InputGroup className="min-width-150">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>{getCurrencySymbol(currency)}</InputGroupText>
        </InputGroupAddon>
        <NumberFormat
          thousandSeparator
          prefix=""
          name={name}
          value={value}
          className="form-control"
          inputMode="numeric"
          allowemptyformatting={allowEmptyFormatting.toString()}
          fixedDecimalScale
          decimalScale={2}
          disabled={disabled}
          defaultValue={defaultValue}
          onBlur={(e) => onBlur(
            e,
            this.state.changedAmount === undefined
              ? defaultValue
              : (this.state.changedAmount === null
                ? 0 : this.state.changedAmount)
          )}
          placeholder={placeholder}
          onValueChange={(values) => this.setState({
            changedAmount: values.floatValue === undefined ? null : values.floatValue,
            value: values.floatValue === undefined ? '' : values.floatValue
          }) }
        />
      </InputGroup>
    );
  }
}

export default CurrencyField;
